export { default } from './JournalCategory';
